import { useSelector } from 'react-redux';

import DescriptionList from '@anwb/poncho/components/description-list';
import Panel from '@anwb/poncho/components/panel';
import { formatPrice } from '@anwb/poncho/utilities/formatters';
import { PanelEditHeader } from 'components/RequestFlow/components/PanelEditHeader/PanelEditHeader';
import { useGaFunnelInfo } from 'hooks/useGaFunnelInfo';
import { chosenDurationSelector, paymentInAdvanceAmountSelector } from 'store/selectors';
import { getMonthlyPriceReduction } from 'utils';
import { STEPS, getStepPathWithCarParam } from 'utils/navigation';

import { customOverviewChangeGA4TrackEvent } from '../util/datalayerEvent';

export const PaymentInAdvance = () => {
	const paymentInAdvanceAmount = useSelector(paymentInAdvanceAmountSelector) ?? 0;
	const duration = useSelector(chosenDurationSelector);
	const gaFunnelInfo = useGaFunnelInfo();

	const title = 'Vooruitbetaling';

	const handleClick = () => {
		customOverviewChangeGA4TrackEvent(title, gaFunnelInfo);
	};

	return (
		<Panel id="payment-in-advance" hasOuterSpacing={false} dataTest="payment-in-advance-overview">
			<Panel.Content>
				<PanelEditHeader
					title={title}
					onClick={handleClick}
					getStepPath={getStepPathWithCarParam}
					stepToEdit={STEPS.CAR_CONTRACT}
					dataTest="payment-in-advance-change-link"
				/>

				<DescriptionList
					items={[
						{
							key: 'Eenmalig bedrag',
							value: formatPrice(paymentInAdvanceAmount, {
								abbreviateCents: true,
							}),
						},
						{
							key: 'Maandelijkse verlaging',
							value: `${formatPrice(
								getMonthlyPriceReduction(Number(duration), -paymentInAdvanceAmount)
							)} per maand`,
						},
					]}
					dataTest="payment-in-advance-description-list"
				/>
			</Panel.Content>
		</Panel>
	);
};
